// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorView_errorContainer__afgAq","errorTitle":"ErrorView_errorTitle__elWXC","errorStacktrace":"ErrorView_errorStacktrace__70Ex2"};